module.exports = __webpack_public_path__ + "static/media/ubcprofs.e04df53a.png";